/** How often to poll subscription stats while the user is signed in / on dashboard. */
export const LIVE_STATS_REFRESH_MS = 5_000;
